import { render, staticRenderFns } from "./photoclaimForm.pug?vue&type=template&id=64e5cd61&lang=pug&external"
import script from "./photoclaimForm.js?vue&type=script&lang=js&external"
export * from "./photoclaimForm.js?vue&type=script&lang=js&external"
import style0 from "./photoclaimForm.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64e5cd61')) {
      api.createRecord('64e5cd61', component.options)
    } else {
      api.reload('64e5cd61', component.options)
    }
    module.hot.accept("./photoclaimForm.pug?vue&type=template&id=64e5cd61&lang=pug&external", function () {
      api.rerender('64e5cd61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/multidamageList/components/photoclaimForm/index.vue"
export default component.exports